import React from 'react';
import { useWindowSize } from '../../helpers/hooks/useWindowSize';
import { useSelector, useDispatch } from 'react-redux';
import NavCollectionsPicker from '../NavCollectionsPicker/NavCollectionsPicker';
import { selectTemplate } from '../../redux/reducers/templateSlice';
import { AdTopWrapper } from '../AdWrappers/AdWrappers';
import { AdBanner, AD_SLOT_TYPE__TOP } from '@emarketer/googleadmanager';

import {
  NavContainer,
  NavPickerContainer,
  NavText,
  NavTrigger,
  NavTriggerLeft,
  NavTriggerRight,
  NavTriggerButton,
  NavTriggerContainer,
  BannerWrapper,
  TextDetail,
  TextHeader,
} from './Navigation.styled';

import { navigation_toggle_open, selectOpenNav } from './../../redux/reducers/navigationSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { COLOR } from '../../theme/constants';

interface INavigationProps {
  selectedGeography: string;
  selectedCollectionName: string;
}

const Navigation: React.FC<INavigationProps> = ({ selectedGeography, selectedCollectionName }: INavigationProps) => {
  const isLoaded = useSelector(selectTemplate).loaded;
  const isMobile = useWindowSize().isMobile;

  const openNav = useSelector(selectOpenNav);
  const dispatch = useDispatch();

  selectedGeography = selectedGeography === '' ? 'Compare Countries' : selectedGeography;

  return (
    <NavContainer open={openNav}>
      <BannerWrapper>
        <TextHeader>This page is not optimized for mobile viewing.</TextHeader>
        <TextDetail>For the best experience, please log in on desktop and navigate to Forecasts.</TextDetail>
      </BannerWrapper>
      <AdTopWrapper>
        <AdBanner adSlotType={AD_SLOT_TYPE__TOP} />
      </AdTopWrapper>
      <NavTrigger data-analytics="Forecasts-Navigation-Open">
        {isLoaded && (
          <NavTriggerButton buttonType="none" callback={() => dispatch(navigation_toggle_open())}>
            <NavTriggerContainer justifyContent="space-between" flexDirection="row">
              <NavTriggerLeft justifyContent="start" spaceBetween={10} flexDirection="row">
                <NavText>{selectedGeography}</NavText>
                <FontAwesomeIcon icon={faChevronRight} width={9} color={COLOR.BLUE} />
                <NavText>{selectedCollectionName}</NavText>
              </NavTriggerLeft>
              <NavTriggerRight>
                <FontAwesomeIcon icon={faChevronDown} width={15} color={COLOR.BLUE} />
              </NavTriggerRight>
            </NavTriggerContainer>
          </NavTriggerButton>
        )}
        {openNav ? (
          <NavPickerContainer>
            <NavCollectionsPicker isMobile={isMobile} isHomePage={false} />
          </NavPickerContainer>
        ) : null}
      </NavTrigger>
    </NavContainer>
  );
};

export default Navigation;
